import { render, staticRenderFns } from "./dashboard-attention.vue?vue&type=template&id=11d54d5e&scoped=true"
import script from "./dashboard-attention.vue?vue&type=script&lang=js"
export * from "./dashboard-attention.vue?vue&type=script&lang=js"
import style0 from "./dashboard-attention.vue?vue&type=style&index=0&id=11d54d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d54d5e",
  null
  
)

export default component.exports